import { render, staticRenderFns } from "./kpsrOnePageDetail.vue?vue&type=template&id=108a2a6c"
import script from "./kpsrOnePageDetail.vue?vue&type=script&lang=js"
export * from "./kpsrOnePageDetail.vue?vue&type=script&lang=js"
import style0 from "./kpsrOnePageDetail.vue?vue&type=style&index=0&id=108a2a6c&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108a2a6c')) {
      api.createRecord('108a2a6c', component.options)
    } else {
      api.reload('108a2a6c', component.options)
    }
    module.hot.accept("./kpsrOnePageDetail.vue?vue&type=template&id=108a2a6c", function () {
      api.rerender('108a2a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/kpsrOnePageDetail.vue"
export default component.exports